import React from "react";

export function SellTitle({title}) {
    return (<div className={"rounded bg-light-blue2 p-2"}>
        <h5 className={"fw-bold text-primary m-0"}>{title}</h5>
    </div>);
}
